// extracted by mini-css-extract-plugin
export default {"answer":"styles_answer__Clg5C","checkbox":"styles_checkbox__aRpaW","text":"styles_text__J7+qv","selected":"styles_selected__idu-A"};